export default "__VITE_ASSET__DJQ1IsNA__"